import { GET_ALL_COUNTRY } from '../../types'

const INITIAL_STATE = {
  allCountries: [],
}

const getCountry = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_COUNTRY:
      return {
        ...state,
        allCountries: payload.data,
      }
    default:
      return state
  }
}

export default getCountry
